import api from "./interceptor";
import * as config from "../config/config";
import moment from "moment";

export const getProspections = async () => {
  const res = await api.get(config.REACT_APP_ENDPOINT_LIST_PROSPECTION);
  return res.data;
};

export const updateProspectionStatus = async (id, payload) => {
  payload.user_id = localStorage.getItem("user_id");
  const res = await api.put(
    `${config.REACT_APP_ENDPOINT_UPDATE_STATUS_PROSPECTION}/${id}/status`,
    payload
  );
  return res.data;
};

export const createRelance = async (id, payload) => {
  payload.user_id = localStorage.getItem("user_id");
  const res = await api.post(
    `${config.REACT_APP_ENDPOINT_CREATE_RELANCE}/${id}/relance`,
    payload
  );
  return res.data;
};

export const getHistorique = async (id) => {
  const res = await api.get(
    `${config.REACT_APP_ENDPOINT_HISTORIQUE_PROSPECTION}/${id}/historique`
  );
  return res.data;
};

export const createProspection = async (payload) => {
  const data = {
    ...payload,
    date_depart: payload.date_depart
      ? moment(payload.date_depart).format("YYYY-MM-DD HH:mm:ss")
      : null,
    date_arrive: payload.date_arrive
      ? moment(payload.date_arrive).format("YYYY-MM-DD HH:mm:ss")
      : null,
  };

  const res = await api.post(
    config.REACT_APP_ENDPOINT_CREATE_PROSPECTION,
    data
  );

  return res.data;
};

export const updateProspection = async (data) => {
  const res = await api.put(
    config.REACT_APP_ENDPOINT_UPDATE_PROSPECTION + data['id'],
    data
  );

  return res.data;
};


